import Accordion from './accordion.js';

export default class AccordionController {
    constructor() {
        this.selector = '.accordion:not(.locked)';
        this.accordions = [];

        this.init();
    }

    init() {
        document.querySelectorAll(this.selector).forEach(container => {
            let accordion = new Accordion(container);
            this.accordions.push(accordion);

            accordion.init();
        });
    }
}